var map = {
	"./de/auth.json": 67754,
	"./de/blocker.json": 9646,
	"./de/buyerProfile.json": 88208,
	"./de/cart.json": 58725,
	"./de/catalog.json": 39756,
	"./de/checkout.json": 62751,
	"./de/color.json": 50591,
	"./de/common.json": 21545,
	"./de/countries.json": 95118,
	"./de/feature.json": 1341,
	"./de/industry.json": 71812,
	"./de/landing.json": 79727,
	"./de/marketing.json": 23531,
	"./de/meta.json": 72300,
	"./de/modals.json": 13516,
	"./de/products.json": 96349,
	"./de/profile.json": 24234,
	"./de/standards.json": 11559,
	"./de/supplier.json": 94788,
	"./de/url.json": 18481,
	"./de/useCase.json": 37975,
	"./en/auth.json": 77542,
	"./en/blocker.json": 18717,
	"./en/buyerProfile.json": 25701,
	"./en/cart.json": 99012,
	"./en/catalog.json": 37348,
	"./en/checkout.json": 64811,
	"./en/color.json": 35005,
	"./en/common.json": 40464,
	"./en/countries.json": 74175,
	"./en/feature.json": 52423,
	"./en/industry.json": 37000,
	"./en/landing.json": 39942,
	"./en/marketing.json": 80420,
	"./en/meta.json": 97002,
	"./en/modals.json": 65121,
	"./en/products.json": 31056,
	"./en/profile.json": 81140,
	"./en/standards.json": 14403,
	"./en/supplier.json": 11426,
	"./en/url.json": 62807,
	"./en/useCase.json": 21430,
	"./fi/auth.json": 82159,
	"./fi/blocker.json": 77583,
	"./fi/buyerProfile.json": 90027,
	"./fi/cart.json": 57138,
	"./fi/catalog.json": 99961,
	"./fi/checkout.json": 62088,
	"./fi/color.json": 15887,
	"./fi/common.json": 8418,
	"./fi/countries.json": 6104,
	"./fi/feature.json": 88484,
	"./fi/industry.json": 23893,
	"./fi/landing.json": 68799,
	"./fi/marketing.json": 18161,
	"./fi/meta.json": 43468,
	"./fi/modals.json": 26562,
	"./fi/products.json": 31787,
	"./fi/profile.json": 5831,
	"./fi/standards.json": 39458,
	"./fi/supplier.json": 29354,
	"./fi/url.json": 18771,
	"./fi/useCase.json": 59405,
	"./sv/auth.json": 53140,
	"./sv/blocker.json": 85088,
	"./sv/buyerProfile.json": 64456,
	"./sv/cart.json": 54997,
	"./sv/catalog.json": 93280,
	"./sv/checkout.json": 47646,
	"./sv/color.json": 73743,
	"./sv/common.json": 56504,
	"./sv/countries.json": 74582,
	"./sv/feature.json": 70425,
	"./sv/industry.json": 36026,
	"./sv/landing.json": 55519,
	"./sv/marketing.json": 32734,
	"./sv/meta.json": 11012,
	"./sv/modals.json": 54310,
	"./sv/products.json": 89629,
	"./sv/profile.json": 66281,
	"./sv/standards.json": 38221,
	"./sv/supplier.json": 95965,
	"./sv/url.json": 45879,
	"./sv/useCase.json": 46491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;